export default {
  formType: 'LABELING_TOOL_GRAPHICS',
  settings: {
    labelSourceSection: 'polygon',
    labelSourceField: 'type',
  },
  data: {
    // 模块
    block: [
      {
        fieldName: 'id',
        label: '块ID',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: true,
      },
    ],
    point: [
      {
        fieldName: 'block_id',
        label: '关联块ID',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
      {
        fieldName: 'type',
        label: '类型',
        dataType: 'string',
        inputMethod: 'select',
        default: '0',
        disabled: false,
        options: [
          {
            value: '11',
            label: '车位与道路连接点',
          },
          {
            value: '12',
            label: '十字路口',
          },
          {
            value: '13',
            label: '区域中心',
          },
          {
            value: '14',
            label: '出入口',
          },
          {
            value: '15',
            label: '车位',
          },
          {
            value: '17',
            label: '登机口',
          },
          {
            value: '18',
            label: '地图连接点',
          },
          {
            value: '0',
            label: '无',
          },
          {
            value: '1',
            label: '店铺',
          },
          {
            value: '2',
            label: '电梯楼梯',
          },
          {
            value: '3',
            label: '公共设施',
          },
          {
            value: '4',
            label: '大屏设备',
          },
          {
            value: '6',
            label: '停车场',
          },
          {
            value: '16',
            label: '停车场入口',
          },
          {
            value: '7',
            label: '地铁',
          },
          {
            value: '91',
            label: '全景点位(勿选)',
          },
          {
            value: '92',
            label: '模型数据(勿选)',
          },
        ],
      },
      {
        fieldName: 'store_type',
        label: '店铺分类',
        dataType: 'string',
        inputMethod: 'select',
        default: '0',
        disabled: false,
        bindings: [
          {
            type: '1',
          },
        ],
        options: [
          {
            value: '0',
            label: '无',
          },
          {
            value: '1',
            label: '时尚配饰',
          },
          {
            value: '2',
            label: '甜品饮料',
          },
          {
            value: '3',
            label: '美食',
          },
          {
            value: '4',
            label: '配套',
          },
          {
            value: '5',
            label: '超市',
          },
          {
            value: '6',
            label: '生活家居/影音',
          },
          {
            value: '7',
            label: '女装',
          },
          {
            value: '8',
            label: '个人护理/药品',
          },
          {
            value: '9',
            label: '鞋包',
          },
          {
            value: '10',
            label: '钟表/珠宝/饰品',
          },
          {
            value: '11',
            label: '休闲服/运动用品',
          },
          {
            value: '12',
            label: '男装',
          },
          {
            value: '13',
            label: '儿童天地',
          },
          {
            value: '14',
            label: '儿童零售',
          },
          {
            value: '15',
            label: '影院',
          },
        ],
      },
      {
        fieldName: 'category_2',
        label: '电梯是',
        dataType: 'string',
        inputMethod: 'select',
        default: '',
        disabled: false,
        bindings: [
          {
            type: '2',
          },
        ],
        options: [
          {
            value: '1',
            label: '步行梯',
          },
          {
            value: '2',
            label: '直梯',
          },
          {
            value: '3',
            label: '双向扶梯',
          },
          {
            value: '4',
            label: '上行扶梯',
          },
          {
            value: '5',
            label: '下行扶梯',
          },
          {
            value: '6',
            label: '扶梯出口',
          },
        ],
      },
      {
        fieldName: 'is_pay_card',
        label: '是否刷卡',
        dataType: 'string',
        inputMethod: 'select',
        default: '0',
        disabled: false,
        bindings: [
          {
            type: '2',
          },
        ],
        options: [
          {
            value: '1',
            label: '是',
          },
          {
            value: '0',
            label: '否',
          },
        ],
      },
      {
        fieldName: 'category_3',
        label: '公共设施是',
        dataType: 'string',
        inputMethod: 'select',
        default: '',
        disabled: false,
        bindings: [
          {
            type: '3',
          },
        ],
        options: [
          {
            value: '1',
            label: '洗手间',
          },
          {
            value: '2',
            label: '服务台',
          },
        ],
      },
      {
        fieldName: 'screen_angle',
        label: '大屏角度',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
        bindings: [
          {
            type: '4',
          },
        ],
      },
      {
        fieldName: 'pano_id',
        label: '全景点位ID',
        dataType: 'number',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
      {
        fieldName: 'store_id',
        label: 'POI关联ID',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
        // bindings: [
        //   {
        //     type: '1',
        //   },
        // ],
      },
      {
        fieldName: 'external_store_id',
        label: '千目店铺code',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
        bindings: [
          {
            type: '1',
          },
        ],
      },
      {
        fieldName: 'name',
        label: '名称',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
      {
        fieldName: 'level',
        label: 'poi优先级',
        dataType: 'number',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
    ],
    // 全景点配置
    PanoramaPoint: [
      {
        fieldName: 'pano_id',
        label: '全景点位ID',
        dataType: 'number',
        inputMethod: 'input',
        default: '',
        disabled: true,
      },
      {
        fieldName: 'seq_id',
        label: 'seq_id',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: true,
      },
      {
        fieldName: 'is_route',
        label: '是否为路口点',
        dataType: 'string',
        inputMethod: 'select',
        default: '',
        disabled: false,
        options: [
          {
            value: '0',
            label: '是',
          },
          {
            value: '1',
            label: '否',
          },
        ],
      },
    ],
    // 大屏点配置
    Screen: [
      {
        fieldName: 'block_id',
        label: '关联块ID',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
      {
        fieldName: 'type',
        label: '类型',
        dataType: 'string',
        inputMethod: 'select',
        default: '4',
        disabled: false,
        options: [
          {
            value: '4',
            label: '大屏',
          },
        ],
      },
      {
        fieldName: 'screen_angle',
        label: '大屏角度',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
      {
        fieldName: 'pano_id',
        label: '全景点位ID',
        dataType: 'number',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
      {
        fieldName: 'name',
        label: '名称',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
    ],
    // 直梯点配置
    Elevator: [
      {
        fieldName: 'block_id',
        label: '关联块ID',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
      {
        fieldName: 'type',
        label: '类型',
        dataType: 'string',
        inputMethod: 'select',
        default: '2',
        disabled: false,
        options: [
          {
            value: '2',
            label: '直梯',
          },
        ],
      },
      {
        fieldName: 'category_2',
        label: '方向',
        dataType: 'string',
        inputMethod: 'select',
        default: '2',
        disabled: false,
        bindings: [
          {
            type: '2',
          },
        ],
        options: [
          {
            value: '2',
            label: '直梯',
          },
        ],
      },
      {
        fieldName: 'pano_id',
        label: '全景点位ID',
        dataType: 'number',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
      {
        fieldName: 'name',
        label: '名称',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
    ],
    // 扶梯点配置
    Escalator: [
      {
        fieldName: 'block_id',
        label: '关联块ID',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
      {
        fieldName: 'type',
        label: '类型',
        dataType: 'string',
        inputMethod: 'select',
        default: '2',
        disabled: false,
        options: [
          {
            value: '2',
            label: '扶梯',
          },
        ],
      },
      {
        fieldName: 'category_2',
        label: '方向',
        dataType: 'string',
        inputMethod: 'select',
        default: '',
        disabled: false,
        options: [
          {
            value: '1',
            label: '步行梯',
          },
          // {
          //   value: '2',
          //   label: '直梯',
          // },
          {
            value: '3',
            label: '双向扶梯',
          },
          {
            value: '4',
            label: '上行扶梯',
          },
          {
            value: '5',
            label: '下行扶梯',
          },
          {
            value: '6',
            label: '扶梯出口',
          },
        ],
      },
      {
        fieldName: 'pano_id',
        label: '全景点位ID',
        dataType: 'number',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
      {
        fieldName: 'name',
        label: '名称',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
    ],
    // 多边形配置
    polygon: [
      {
        fieldName: 'block_id',
        label: '关联块ID',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
      {
        fieldName: 'type',
        label: '类型',
        dataType: 'string',
        inputMethod: 'select',
        default: '',
        disabled: false,
        options: [
          {
            value: '',
            label: '无',
          },
          {
            value: '1',
            label: '车位',
          },
          {
            value: '2',
            label: '区域',
          },
        ],
      },
      {
        fieldName: 'parking_id',
        label: '车位号',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
        bindings: [
          {
            type: '1',
          },
        ],
      },
      {
        fieldName: 'area_group',
        label: '所属区域',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
        bindings: [
          {
            type: '1',
          },
        ],
      },
      {
        fieldName: 'parking_group',
        label: '车组',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
        bindings: [
          {
            type: '1',
          },
        ],
      },
      {
        fieldName: 'area_type',
        label: '区域类型',
        dataType: 'string',
        inputMethod: 'select',
        default: '其他',
        disabled: false,
        bindings: [
          {
            type: '2',
          },
        ],
        options: [
          {
            value: 'Mall',
            label: 'Mall',
          },
          {
            value: '停车场',
            label: '停车场',
          },
          {
            value: '其他',
            label: '其他',
          },
        ],
      },
      {
        fieldName: 'area_id',
        label: '区域ID',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
        bindings: [
          {
            type: '2',
          },
        ],
      },
    ],
    // 线属性设置
    CommonLine: [
      {
        fieldName: 'path_direction',
        label: '通行方向',
        dataType: 'string',
        inputMethod: 'select',
        default: '',
        disabled: false,
        options: [
          {
            value: '',
            label: '请选择',
          },
          {
            value: 'twoward',
            label: '双向通行',
          },
          {
            value: 'forward',
            label: '正向通行',
          },
          {
            value: 'backward',
            label: '反向通行',
          },
        ],
      },
    ],
  },
};
